/**
 * Created by Akihiro-Kato on 2017/03/26.
 */
import React, {Component} from 'react';
// import shouldPureComponentUpdate from 'react-pure-render/function';

import {markerStyle} from './_markerStyle';

export default class MyGreatPlace extends Component {

  static defaultProps = {};

  // shouldComponentUpdate = shouldPureComponentUpdate;

  render() {
    return (
      <div style={markerStyle}>
        {this.props.text}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/js/settings/_marker.js